import React, { createContext, useState, useContext } from 'react';

const ChatbotContext = createContext({
    isOpen: false,
    openModal: () => {},
    closeModal: () => {},
});

export const useChatbotContext = () => useContext(ChatbotContext);

export const ChatbotContextProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    const toggleModal = () => setIsOpen(prevState => !prevState);

    const contextValue = {
        isOpen,
        openModal,
        closeModal,
        toggleModal
    };

    return (
        <ChatbotContext.Provider value={contextValue}>
            {children}
        </ChatbotContext.Provider>
    );
};
